/* eslint-disable @nrwl/nx/enforce-module-boundaries */
/* eslint-disable @angular-eslint/component-selector */
import { CommonModule } from '@angular/common';
import { Component, computed, HostBinding, inject } from '@angular/core';

import { MovieSiteConfigurationService } from '../movie-site-configuration.service';

/**
 * **IMPORTANT** remember add the next input to the custom footer component in the clients to work properly:
 */

/**
 * Input used in the Movie Sites to set the channel logo alternative.
 * TODO implement. If channel logo is not in the footer ignore. The input itself is required.
 */
//mainLogoAlternative = input<string | undefined>(undefined);
/**
 * Input used in the Movie Sites to set the channel logo drop shadow effect.
 * TODO implement. If channel logo is not in the footer ignore. The input itself is required.
 */
//mainLogoDropShadowEffect = input<string | undefined>('white');

@Component({
  selector: 'footer-component',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer-component.component.html',
  styleUrls: ['./footer-component.component.css']
})
export class MovieSiteFooterComponent {
  readonly configService = inject(MovieSiteConfigurationService);
  readonly globalFooterConfig = this.configService.movieSiteConfigGlobal()?.footer || {};

  readonly footerComponent = computed(() => this.configService.footerConfiguration()?.component || undefined);
  readonly logoContrast = computed(
    () => this.configService.footerConfiguration()?.logoContrast || this.globalFooterConfig.logoContrast
  );

  /**
   * By adding this class,
   * */
  @HostBinding('class.disable-drop-shadow') get disableDropShadow() {
    return this.logoContrast() === 'none';
  }

  treatmentChannelLogo = this.configService.footerChannelLogoTreatment;
}
